import React from 'react';
import { List, Typography, Popconfirm, message, Button, Space } from 'antd';
import { CalendarOutlined, DeleteOutlined, EditOutlined } from '@ant-design/icons';
import { Link, useNavigate } from 'react-router-dom';
import { deletePost } from '../../api/localStorage';
import './index.css';

const { Text } = Typography;

const ArchiveItem = ({ archive, onPostDeleted }) => {
  const navigate = useNavigate();
  const { year, posts } = archive;

  const handleDelete = (id) => {
    deletePost(id);
    message.success('文章删除成功！');
    if (onPostDeleted) {
      onPostDeleted(id); // 通知父组件更新文章列表
    }
  };

  const handleEdit = (id) => {
    navigate(`/edit/${id}`);
  };

  return (
    <div className="archive-item">
      <h2>{year}年</h2>
      <List
        dataSource={posts}
        renderItem={(post) => (
          <List.Item
            actions={[
              <Space key="edit-delete-space">
                <Button type="text" size="small" icon={<EditOutlined />} onClick={() => handleEdit(post.id)}>
                  编辑
                </Button>
                <Popconfirm
                  key="delete"
                  title="确认删除"
                  description="您确定要删除这篇文章吗？此操作不可撤销。"
                  okText="确定"
                  cancelText="取消"
                  onConfirm={() => handleDelete(post.id)}
                >
                  <Button type="text" danger size="small" icon={<DeleteOutlined />}>
                    删除
                  </Button>
                </Popconfirm>
              </Space>
            ]}
          >
            <List.Item.Meta
              avatar={<CalendarOutlined />}
              title={<Link to={`/post/${post.id}`}>{post.title}</Link>}
              description={<Text type="secondary">{post.date}</Text>}
            />
          </List.Item>
        )}
      />
    </div>
  );
};

export default ArchiveItem;